<template>
    <div class="af-job-alert-frequency afu-flex afu-items-center afu-flex-wrap afu-gap-4 md:afu-gap-0">
        <C1Button
            v-for="(option, index) in options"
            :key="`option_${index}`"
            class="af-job-alert-frequency-item afu-mr-2 fist:afu-ml-0 last:afu-mr-0 afu-cursor-pointer af-text--xl"
            style="min-width: 100px; font-weight: normal;"
            :class="{ 'is-active': option.value === currentValue.value }"
            :variant="option.value === currentValue.value ? 'secondary' : 'neutral'"
            @click.stop.prevent="updateValue(option.value)"
        >
            {{ option.label }}
        </C1Button>
    </div>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'C1RadioButton',

        components: {
            C1Button,
        },

        props: {
            currentValue: {
                type: Object,
                default: () => ({}),
            },
            options: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            updateValue(value) {
                if (value !== this.currentValue.value) {
                    this.currentValue.value = value;
                    this.$emit('updateValue', value);
                }
            },
        },
    };
</script>
